// eslint-disable-next-line import/no-unresolved
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// pdfjs-dist references DOMMatrix at module load, which breaks jsdom/happy-dom tests. Load it lazily.
let pdfjsPromise: Promise<typeof import('pdfjs-dist')> | null = null;

export const loadPdfjs = () => {
  if (!pdfjsPromise) {
    pdfjsPromise = import('pdfjs-dist')
      .then((mod) => {
        mod.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
        return mod;
      })
      .catch((error) => {
        pdfjsPromise = null;
        throw error;
      });
  }
  return pdfjsPromise;
};
